import { render, staticRenderFns } from "./ModalOrgaosParticipantes.vue?vue&type=template&id=47839d44"
import script from "./ModalOrgaosParticipantes.vue?vue&type=script&lang=js"
export * from "./ModalOrgaosParticipantes.vue?vue&type=script&lang=js"
import style0 from "./ModalOrgaosParticipantes.vue?vue&type=style&index=0&id=47839d44&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports